<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    title="企业信息"
    width="600px"
    @close="close"
  >
    <el-row>
      <el-col :span="5">企业名称</el-col>
      <el-col :span="19">{{ showForm.title }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="5">企业ID</el-col>
      <el-col :span="19">{{ showForm.id }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="5">有效期至</el-col>
      <el-col :span="19">{{ showForm.endValidDate }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="5">短信可用数量</el-col>
      <el-col :span="19">{{ showForm.smsCount }}</el-col>
    </el-row>
    <template #footer>
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { getAppConfig } from '@/api/super'
import { getApp } from '@/api/settings'
export default {
  name: 'Information',
  data() {
    return {
      labelPosition: 'right',
      showForm: {
        title: '',
        id: '',
        smsCount: 0,
        endValidDate: '',
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showInformation() {
      const ret = await getApp()
      const config = await getAppConfig({ clientAppId: ret.appId, key: 'APP_AVAIL' })
      this.showForm = {
        title: ret && ret.title || '',
        id: ret && ret.appId || '',
        smsCount: config && config.basic && config.basic.smsCount || 0,
        endValidDate: config && config.basic && config.basic.endValidDate || ''
      }
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  :deep() {
    .el-col {
      user-select: text;
    }
  }
}

</style>
